/**
 * Reading History Module
 * Tracks reading progress and displays badges on post cards
 */

function initReadingHistory() {
    const postBody = document.getElementById('post-body');
    
    if (!postBody) {
        updatePostCardBadges();
        return;
    }
    
    const postUrl = window.location.pathname;
    const storageKey = 'reading_history';
    const history = JSON.parse(localStorage.getItem(storageKey) || '{}');
    
    let lastScrollPercent = 0;
    let ticking = false;
    
    function trackProgress() {
        if (history[postUrl]?.completed) return;
        
        const postBodyTop = postBody.offsetTop;
        const postBodyHeight = postBody.offsetHeight;
        const windowHeight = window.innerHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollIntoPost = scrollTop - postBodyTop;
        const scrollableHeight = postBodyHeight - windowHeight;
        const scrollPercent = Math.max(0, Math.min((scrollIntoPost / scrollableHeight) * 100, 100));
        
        lastScrollPercent = Math.round(scrollPercent);
        
        if (lastScrollPercent % 5 === 0) {
            history[postUrl] = {
                percent: lastScrollPercent,
                scrollPosition: scrollTop,
                timestamp: Date.now(),
                completed: lastScrollPercent >= 95
            };
            localStorage.setItem(storageKey, JSON.stringify(history));
            
            window.dispatchEvent(new CustomEvent('reading-progress-updated', { 
                detail: { url: postUrl, progress: history[postUrl] } 
            }));
        }
    }
    
    window.addEventListener('scroll', () => {
        if (ticking) return;
        
        window.requestAnimationFrame(() => {
            trackProgress();
            ticking = false;
        });
        ticking = true;
    });
    
    const savedProgress = history[postUrl];
    if (savedProgress && !savedProgress.completed && savedProgress.percent > 10) {
        showContinueReadingToast(savedProgress);
    }
    
    window.addEventListener('beforeunload', () => {
        if (lastScrollPercent >= 95 && (!history[postUrl] || !history[postUrl].completed)) {
            history[postUrl] = {
                percent: 100,
                scrollPosition: 0,
                timestamp: Date.now(),
                completed: true
            };
            localStorage.setItem(storageKey, JSON.stringify(history));
            
            window.dispatchEvent(new CustomEvent('reading-progress-updated', { 
                detail: { url: postUrl, progress: history[postUrl] } 
            }));
        }
    });
}

function showContinueReadingToast(progress) {
    const toast = document.getElementById('continue-reading-toast');
    const percentSpan = document.getElementById('continue-reading-percent');
    const continueBtn = document.getElementById('continue-reading-btn');
    const dismissBtn = document.getElementById('continue-reading-dismiss');
    
    if (!toast) return;
    
    percentSpan.textContent = `${progress.percent}%`;
    
    setTimeout(() => {
        toast.classList.remove('opacity-0', 'translate-y-full');
        toast.classList.add('opacity-100', 'translate-y-0');
    }, 1000);
    
    continueBtn.addEventListener('click', () => {
        window.scrollTo({ top: progress.scrollPosition, behavior: 'smooth' });
        hideToast();
    });
    
    dismissBtn.addEventListener('click', hideToast);
    
    function hideToast() {
        toast.classList.remove('opacity-100', 'translate-y-0');
        toast.classList.add('opacity-0', 'translate-y-full');
    }
    
    setTimeout(hideToast, 10000);
}

function updatePostCardBadges() {
    const postCards = document.querySelectorAll('[data-post-url]');
    if (postCards.length === 0) return;
    
    const storageKey = 'reading_history';
    const history = JSON.parse(localStorage.getItem(storageKey) || '{}');
    
    postCards.forEach(card => {
        const postUrl = card.dataset.postUrl;
        const normalizeUrl = (url) => url.replace(/\/$/, '');
        const normalizedUrl = normalizeUrl(postUrl);
        
        const progress = history[postUrl] || history[normalizedUrl] || history[`${normalizedUrl}/`];
        
        const statusOverlay = card.querySelector('.reading-status-overlay');
        const progressOverlay = card.querySelector('.reading-progress-overlay');
        const postImage = card.querySelector('.post-card-image');
        const article = card.closest('article');
        const postTitle = article?.querySelector('.post-card-title');
        const postExcerpt = article?.querySelector('.post-card-excerpt');
        const postMeta = article?.querySelector('.post-card-meta');
        
        if (!statusOverlay || !progressOverlay || !postImage) return;
        
        if (progress?.completed) {
            statusOverlay.classList.remove('hidden');
            statusOverlay.classList.add('flex');
            progressOverlay.classList.add('hidden');
            progressOverlay.classList.remove('flex');
            postImage.classList.add('grayscale');
            
            postTitle?.classList.add('opacity-50');
            postExcerpt?.classList.add('opacity-40');
            postMeta?.classList.add('opacity-40');
        } else if (progress && progress.percent > 10 && !progress.completed) {
            const progressText = progressOverlay.querySelector('.reading-progress-percent');
            if (progressText) progressText.textContent = `${progress.percent}%`;
            
            progressOverlay.classList.remove('hidden');
            progressOverlay.classList.add('flex');
            statusOverlay.classList.add('hidden');
            statusOverlay.classList.remove('flex');
            postImage.classList.remove('grayscale');
            
            postTitle?.classList.remove('opacity-50');
            postExcerpt?.classList.remove('opacity-40');
            postMeta?.classList.remove('opacity-40');
        } else {
            statusOverlay.classList.add('hidden');
            statusOverlay.classList.remove('flex');
            progressOverlay.classList.add('hidden');
            progressOverlay.classList.remove('flex');
            postImage.classList.remove('grayscale');
            
            postTitle?.classList.remove('opacity-50');
            postExcerpt?.classList.remove('opacity-40');
            postMeta?.classList.remove('opacity-40');
        }
    });
}
